import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuList,
} from '@/components/ui/navigation-menu'
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area'
import { cn } from '@/lib/utils'
import { PropsWithChildren } from 'react'
import { NavLink as ReactRouterNavLink, To } from 'react-router'
import { buildPath } from '@/routes'
import { Case } from '@/@types/generated'

interface CaseDetailsNavigationProps {
  case: Case
}

export default function CaseDetailsNavigation({
  case: { id },
}: CaseDetailsNavigationProps) {
  if (!id) return null
  const caseId = String(id)

  return (
    <div className="bg-primary text-primary-foreground rounded-md p-4">
      <ScrollArea className="-mb-2 w-full pb-1 whitespace-nowrap">
        <NavigationMenu>
          <NavigationMenuList className="flex gap-4 lg:gap-6">
            <CaseDetailsNavigation.Item
              to={buildPath('/cases/:caseId/complaint', { caseId })}
            >
              Complaint Details
            </CaseDetailsNavigation.Item>
            <CaseDetailsNavigation.Item
              to={buildPath('/cases/:caseId/investigation', { caseId })}
            >
              Investigation Details
            </CaseDetailsNavigation.Item>
            <CaseDetailsNavigation.Item
              to={buildPath('/cases/:caseId/violations', { caseId })}
            >
              Violations
            </CaseDetailsNavigation.Item>
            <CaseDetailsNavigation.Item
              to={buildPath('/cases/:caseId/notices', { caseId })}
            >
              Notices
            </CaseDetailsNavigation.Item>
            <CaseDetailsNavigation.Item
              to={buildPath('/cases/:caseId/history', { caseId })}
            >
              History
            </CaseDetailsNavigation.Item>
          </NavigationMenuList>
        </NavigationMenu>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
    </div>
  )
}

CaseDetailsNavigation.Item = function CaseDetailsNavigationItem({
  to,
  children,
}: PropsWithChildren<{ to: To }>) {
  return (
    // Bottom padding to account for scrollbar height to show underline decoration
    <NavigationMenuItem className="pb-1">
      <ReactRouterNavLink
        to={to}
        className={({ isActive }) =>
          cn(
            'hover:decoration-primary-foreground whitespace-nowrap underline decoration-transparent decoration-2 underline-offset-6 transition-colors duration-200',
            isActive ? 'decoration-primary-foreground' : null
          )
        }
      >
        {children}
      </ReactRouterNavLink>
    </NavigationMenuItem>
  )
}
